module.exports = __webpack_public_path__ + "img/depot.4f043d21.png";